import {
  claimDailyReward,
  queryDailyRewardsList,
  SRewardItem,
} from '@/apis/rewards';
import RewardsHeader from '@/components/biz/rewards/helper';
import WrappedButton from '@/components/ui/WrappedButton';
import { TInferSchemaType } from '@/constants/schemas';
import queryKeysFactory from '@/reactQueryKeys/keysFactory';
import queryClient from '@/reactQueryKeys/queryClient';
import useTheme from '@/theme/useTheme';
import { UnpackPromise } from '@/utils/type';
import { Divider, Stack } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useRequest } from 'ahooks';
import { useTranslation } from 'next-i18next';
import toast from 'react-hot-toast';
const BonusCardItem: React.FC<{
  bonus: TInferSchemaType<typeof SRewardItem>;
  mt?: number;
}> = ({ bonus, mt }) => {
  const { theme } = useTheme();

  const [t] = useTranslation();

  const { run: claimReward, loading: loadingClaimReward } = useRequest(
    (bonus: string) => {
      return claimDailyReward(bonus);
    },
    {
      manual: true,
      onSuccess: (data) => {
        queryClient.invalidateQueries(
          queryKeysFactory.rewards.dailyRewardsAll(),
        );
        toast.success(t('Claim Success!'));
      },
    },
  );

  // const rakeBackReward = (rewardsListData?.data.rewards || []).find(
  //   (reward) => reward.bonus === 'RAKEBACK',
  // );

  return (
    <Stack
      sx={{
        background: (theme) => theme.palette.bg.secondary,
        padding: 3,
      }}
      justifyContent={'flex-start'}
      borderRadius={1}
      mt={mt}
    >
      <RewardsHeader
        rewardType={bonus.bonus}
        claimableAmount={bonus?.availableAmount ?? 0}
        layout={'card'}
      />
      <Divider
        sx={{
          borderColor: 'transparent',
          my: 4,
          display: bonus.bonus === 'RAKEBACK' ? 'none' : 'block',
          flex: 1,
        }}
      />
      <WrappedButton
        isLoading={loadingClaimReward}
        onClick={() => {
          claimReward(bonus.bonus);
        }}
        disabled={!bonus || bonus?.availableAmount <= 0}
        sx={{
          width: '100%',
        }}
      >
        {t('Claim')}
      </WrappedButton>
    </Stack>
  );
};

export default BonusCardItem;
